<div
  class="bg-france bg-no-repeat h-[466px] bg-cover relative text-white text-xl lg:text-4xl
  text-center font-poppins font-bold flex flex-col justify-center items-center">
  <div class="bg-[#478E88] w-3/4 mt-2">
    <h2>Você também ama a língua francesa?</h2>
  </div>
  <div class="bg-[#478E88] w-3/4 mt-2">
    <h2>Já se imaginou viajando, morando ou</h2>
  </div>
  <div class="bg-[#478E88] w-5/6">
    <h2>
      estudando na França e conseguindo se comunicar sem dificuldade neste país
      lindo?
    </h2>
  </div>
</div>
